import { FontDescription } from "./FontDescription";
import { FontInfo } from "./FontInfo"
import { Jost, Jost_300, Jost_400 } from "./library/Jost"
import { JosefinSans } from "./library/JosefinSans"

interface FontFamily
{
  fonts:FontInfo[]
}

export class FontLibrary
{
  static readonly fontFamilies:FontFamily[] = 
  [
    Jost,
    JosefinSans
  ]

  private static _lookUpCache:Map<string,FontInfo> = null;
  private static _defaultFontInfo = new Jost_400();
  private static _regularWeight   = 400;
  private static _boldWeight      = 700;

  
  static getFontInfo( fontDescription:FontDescription )
  {
    FontLibrary._createLookUp();
    
    let hash = FontInfo.hashName( fontDescription );

    if ( FontLibrary._lookUpCache.has( hash ) )
    {
      return FontLibrary._lookUpCache.get( hash );
    }

    return this._defaultFontInfo;

  }

  static _createLookUp()
  {
    if ( this._lookUpCache !== null )
    {
      return;
    }

    this._lookUpCache = new Map<string,FontInfo>();

    FontLibrary.fontFamilies.forEach(
      ( family )=>
      {
        family.fonts.forEach(
          ( font )=>
          {
            let hash = FontInfo.hashName( font );
            this._lookUpCache.set( hash, font );
          }
        );
      }
    );

  }  

}